/*
 * @Author: qian.tang
 * @Date: 2023-09-21 10:30:26
 * @LastEditors: Qian Tang qian@itrazotracetech.com
 * @LastEditTime: 2024-01-22 10:12:18
 * @FilePath: \itrazo-portal-dev\src\containers\Pages\AssetManagement\statics\constants.tsx
 * @Description: 
 * 
 * Copyright (c) 2023 by ${git_name_email}, All Rights Reserved. 
 */


export const ALLOCATION_REQUEST_TYPES: { [key: string]: { label: string, value: string } } = {
  request: {
    label: "New Asset Requests",
    value: "request",
  },
  retrieval: {
    label: "Asset Retrieval Requests",
    value: "retrieval",
  }
};

export const ALLOCATION_REQUEST_STATUS: { [key: string]: string } = {
  OUTSTANDING: "outstanding",
  ALLOCATED: 'allocated',
  PARTIALLY_ALLOCATED: 'partially_allocated',
  DISPATCHED: "dispatched",
  DELIVERED: "delivered",
  RETRIEVAL_REQUEST_CREATED: "retrieval_request_created",
  REJECTED: 'rejected',
  COMPLETED: "completed",
};

export const ASSET_STATUS: { [key: string]: string } = {
  UNALLOCATED: "unallocated",
  IN_MAINTENANCE: "in_maintenance",
  ALLOCATED: "allocated",
  DISPOSED: "disposed",
  DISPATCHED: "dispatched",
  DELIVERED: "delivered",
};

// REQUEST: "Order New Asset(s)",
// RETRIEVAL: "Retrieve Existing Asset(s)",